import React from 'react'
import Cart from '../features/cart/Cart'

function CartPage  ()  {
  return (<div>
    <Cart/>
  </div>
    
  )
}

export default CartPage